export const INVALID_FULFILLMENT_SELECTION_MESSAGE =
  "Invalid fulfillment selection";

export const hasInvalidFulfillmentSelectionMessage = (error: unknown): boolean =>
  typeof error === "object" &&
  error !== null &&
  "message" in error &&
  error.message === INVALID_FULFILLMENT_SELECTION_MESSAGE;

export const isInvalidFulfillmentSelectionError = (error: unknown): boolean =>
  typeof error === "object" &&
  error !== null &&
  "status" in error &&
  error.status === 422 &&
  hasInvalidFulfillmentSelectionMessage(error);
